// Module
var code = "<h1 id=\"补充中\">补充中...</h1> <p>资料还在补充中，近期会更新！！！ 请耐心等待~~</p> ";
// Exports
module.exports = code;